import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ChangePasswordResponse, LoginApiResponse } from '../models/login-response';
import { SKIP_AUTH } from '../core/auth/auth-context';
import { StorageService } from './storage.service';
import { TabService } from './tab-service';

export { SKIP_AUTH } from '../core/auth/auth-context';

export interface LoginRequest {
  userName: string;
  password: string;
  domain?: string;
}

export interface ForgotPasswordRequest {
  email: string;
  otp: string;
  password: string;
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class SigninService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly storageService = inject(StorageService);
  private readonly tabService = inject(TabService);
  private readonly signinUrl = `${environment.API_URL}/signin`;
  private readonly userUrl = `${environment.API_URL}/user`;

  doLogin(credentials: LoginRequest): Observable<LoginApiResponse> {
    return this.http.post<LoginApiResponse>(this.signinUrl, credentials, { context: this.publicContext() }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  async doLogout(): Promise<void> {
    this.storageService.clearAll();
    this.tabService.clearTabs();
    await this.router.navigateByUrl('/signin', { replaceUrl: true });
  }

  checkPassword(password: string): Observable<unknown> {
    return this.http.post<unknown>(`${this.userUrl}/checkPassword`, { oldPassword: password });
  }

  // Confirm this path against your RMS controller before enabling forced password change.
  changePassword(data: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this.http.put<ChangePasswordResponse>(`${this.userUrl}/changePassword`, data);
  }

  sendOtp(email: string): Observable<unknown> {
    return this.http.post<unknown>(`${this.signinUrl}/send_otp`, { email: email.trim() }, { context: this.publicContext() });
  }

  sendOTP(email: string): Observable<unknown> { return this.sendOtp(email); }

  updatePassword(data: ForgotPasswordRequest): Observable<unknown> {
    return this.http.put<unknown>(`${this.signinUrl}/forgot_password`, data, { context: this.publicContext() });
  }

  private publicContext(): HttpContext { return new HttpContext().set(SKIP_AUTH, true); }
}
